"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _HorizontalRuleModule = _interopRequireDefault(require("./HorizontalRule.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const HorizontalRule = _ref => {
  let {
    className,
    testAttr,
    spaceTop,
    spaceBottom
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
    className: (0, _cnbuilder.cnb)(_HorizontalRuleModule.default.root, {
      [_HorizontalRuleModule.default["top".concat(spaceTop)]]: spaceTop
    }, {
      [_HorizontalRuleModule.default["bottom".concat(spaceBottom)]]: spaceBottom
    }, className),
    "data-test": testAttr,
    "aria-hidden": "true"
  });
};
HorizontalRule.defaultProps = {
  testAttr: 'hr'
};
var _default = exports.default = HorizontalRule;